window["ThemeTile"] = (link, title) => {
  return {
    hover: false,
    link: link,
    title: title,
    async openQuickView(event) {
      const fromRightDrawer = event.target.dataset.fromRightDrawer === "true";
      this.$store.quickview.render(link);
      this.$store.modals.quickViewDrawer.openedFromRightDrawer =
        fromRightDrawer;
      this.$store.modals.open("productQuickView");
    },
  };
};
